import Dragger from 'antd/es/upload/Dragger'

import { getDraggerClassNames } from 'src/components/FileUpload/util'

import { FileUploadState, FileUploadStatuses } from '../../hooks/use-file-upload-state'

import { Default } from './states/Default'
import { Done } from './states/Done'
import { Error } from './states/Error'
import { Uploading } from './states/Uploading'

export type FileUploadProps = FileUploadState & {
  accept?: string
  children?: React.ReactNode
  error?: boolean
  onRemove?: () => void
}
export const FileUpload = ({
  accept,
  children,
  size,
  setName,
  type,
  status,
  progress,
  name,
  url,
  thumbnailUrl,
  govWellFileId,
  removeFile,
  beforeUpload,
  error,
  errorType,
  reset,
}: FileUploadProps) => {
  const canUpload = [
    FileUploadStatuses.Default,
    FileUploadStatuses.Error,
    FileUploadStatuses.Existing,
    ...(children ? [FileUploadStatuses.Done] : []),
  ].includes(status)

  const isInvalid = !!error || status === FileUploadStatuses.Error
  const isUploaded = status === FileUploadStatuses.Done || status === FileUploadStatuses.Existing
  return (
    <Dragger
      accept={accept}
      name="file"
      action=""
      beforeUpload={beforeUpload}
      openFileDialogOnClick={canUpload}
      className={getDraggerClassNames({
        asChild: !!children,
        isInvalid,
        isUploaded,
      })}
    >
      {children ? (
        children
      ) : (
        <>
          {status === FileUploadStatuses.Default && <Default accept={accept} />}
          {status === FileUploadStatuses.Error && errorType && (
            <Error name={name} errorType={errorType} onClick={reset} />
          )}
          {status === FileUploadStatuses.Uploading && (
            <Uploading fileName={name} onRemove={removeFile} progress={progress} />
          )}
          {[FileUploadStatuses.Done, FileUploadStatuses.Existing].includes(status) && size && (
            <Done
              id={govWellFileId}
              name={name}
              onRenameFile={setName}
              onRemoveFile={removeFile}
              thumbnailUrl={thumbnailUrl}
              type={type}
              url={url}
            />
          )}
        </>
      )}
    </Dragger>
  )
}
